/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Offline_Payment_Pending_WarningInputs */

const en_orders_offline_payment_pending_warning = /** @type {(inputs: Orders_Offline_Payment_Pending_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline payment is still pending. Confirming this will auto-adjust the pending cheque or offline amount.`)
};

const es_orders_offline_payment_pending_warning = /** @type {(inputs: Orders_Offline_Payment_Pending_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pago offline sigue pendiente. Confirmar esto ajustara automaticamente el monto pendiente por cheque u offline.`)
};

/**
* | output |
* | --- |
* | "Offline payment is still pending. Confirming this will auto-adjust the pending cheque or offline amount." |
*
* @param {Orders_Offline_Payment_Pending_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_offline_payment_pending_warning = /** @type {((inputs?: Orders_Offline_Payment_Pending_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Offline_Payment_Pending_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_offline_payment_pending_warning(inputs)
	return es_orders_offline_payment_pending_warning(inputs)
});